<template>
    <el-select
        v-model="localValue"
        filterable
        multiple
        remote
        :multiple-limit="parameters.number_of_values"
        :placeholder="$t.__('common.actions.search')"
        :remote-method="remoteMethod"
        :loading="loading"
        class="wp-10"
    >
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
        >
        </el-option>
    </el-select>
</template>

<script>
import CfMixin from 'mixins/CustomfieldsMixins';

export default {
    mixins: [CfMixin],
    data() {
        return {
            loading: false,
            options: [],
        };
    },
    methods: {
        remoteMethod: _.debounce(function (query) {
            if (query !== '') {
                this.loading = true;

                window.SellsyJS.WebServiceCaller.get(
                    `/rest/catalogue/items/autocomplete`,
                    { q: query, types: this.types },
                    (response) => {
                        this.options = response;
                        this.loading = false;
                    },
                    (error) => {
                        Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                    },
                );
            }
        }, 500),

        /**
         * Send to the parent component the new values of item customfields.
         * In case the new selection, it is only refered by its id (number), push name data in the same key
         * of the related ID.
         * newValue (array): array of services/products
         */
        update(newValue) {
            let value = [];
            newValue.forEach((service) => {
                let id = null;
                let name = null;

                // if id
                if (typeof service === 'number') {
                    id = service;
                    name = this.options.find((option) => option.id === service)?.name;
                } else {
                    let item = this.value.find((option) => option.name === service);
                    if (!_.isNil(item)) {
                        id = item.id;
                        name = item.name;
                    }
                }

                value.push({
                    id: id,
                    name: name,
                    customFieldType: 'item'
                });
            });
            this.$emit('input', { id: this.id, value });
        },
    },
    computed: {
        localValue: {
            get() {
                return this.value?.map((item) => item.name) ?? [];
            },
            set(value) {
                this.update(value);
            },
        },
        /**
         * Get actives types to search
         * Must check value and type of each param
         * parameters: { number_of_values: 1, product: true, service: true }
         */
        types() {
            return _.filter(Object.keys(this.parameters), (value) => {
                return this.parameters[value] === true;
            });
        },
    },
};
</script>
